export default __webpack_public_path__ + "static/media/support-notes-logo-iprofesional.f62b0d0f.svg";